import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { LocationRepository }   from 'Domain/Repositories';
import { message }              from 'antd';

export const deleteLocationEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.deleteLocationRequest.type),
    mergeMap(action => from(LocationRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          message.success('Location wurde erfolgreich gelöscht.');
          return from([
            Actions.deleteLocationSuccess({ id: action.payload.id }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.deleteLocationFailure(error),
          ]);
        })
      )
    ),
  );
};
